import type { FC } from 'react';
import { AICard } from './AiCard/AiCard';
import { useVehicleRecommendationsLink } from './hooks/useVehicleRecommendationsLink';

interface AiVehicleRecommendationsCardContentProps {
    scopeId: string;
    message: string;
    isDisabled?: boolean;
    condensed?: boolean;
}

export const AiVehicleRecommendationsCard: FC<AiVehicleRecommendationsCardContentProps> = ({
    scopeId,
    message,
    isDisabled,
    condensed
}) => {
    const handleLabelClick = useVehicleRecommendationsLink(scopeId);

    return (
        <AICard
            label="Alternative Vehicle Options"
            dataTestId="vehicle-recommendations"
            message={condensed ? '' : message}
            onHandleLabelClick={handleLabelClick}
            disabled={isDisabled}
            showLogo={!condensed}
        />
    );
};
